export const HEADER_LAYOUT = 'web_header';
export const RESULTS_LAYOUT = 'web_search_page';

export const FILTER_NAMES = {
  DATE: 'date',
  TIME: 'time',
  ACTIVITY: 'activity',
  VERTICAL: 'verticals',
  RESULT_TYPE: 'result_type',
  RADIUS: 'radius',
  TO_TIME: 'tt',
  FROM_TIME: 'ft',
  MAP_BOUNDS: 'map_bounds',
  AMENITY: 'amenity',
  LEVEL: 'level',
  CREDITS: 'credits',
};

export const RESULT_TYPES = {
  VENUE: 'VENUE',
  SCHEDULE: 'SCHEDULE',
};

export const EVENTS = {
  changeView: 'Search - Change List View',
  viewMap: 'Search - View Map',
  searchQuery: 'Search - Query',
};

export const AUTO_RADIUS_ID = 0;

export const DESCRIPTION_LENGTH = {
  DEFAULT: 210,
  SHORT: 80,
};

export const INITIAL_VISIBLE_VENUE_COUNT = 50;

export const DEFAULT_GEOLOCATION = {
  lat: 40.715,
  lon: -73.997,
  name: 'New York',
  timezone: 'America/New_York',
};

export const VERTICALS = {
  all: 'all',
  fitness: 'fitness',
  wellness: 'wellness',
  gym: 'gym',
};

export const CREDITS_FILTER_MIN_CREDITS = 0;
export const CREDITS_FILTER_MAX_CREDITS = 13;
